class Validator{
    "use strict";

    constructor(elements){
        this.elements = elements;
        this.currentName = null;
        this.current = null;
    }

    get(name){
        this.currentName = name;
        this.current = this.elements[name];
        return this;
    }

    returnError(errorText){
        notify.createNotifier(errorText,"danger",4000);
        throw "validate failed";
    }

    isNotNull(){
        let ret = !!this.current;
        if(!ret || ret === 0 ){
            this.returnError(`Element ${this.currentName} nie może być pusty`);
        }
        return this;
    }

    isString(){
        this.isNotNull();
        let ret = (typeof this.current) === "string";
        if(!ret){
            this.returnError(`Element ${this.currentName} musi być stringiem`);
        }
        return this;
    }

    length(min = 0, max = null){
        this.isString();
        let ret = this.current.length >= min;
        if(max&&ret) {
            ret = this.current.length <= max;
        }
        if(!ret){
            this.returnError(`Element ${this.currentName} musi mieć długość w przedziale (${min+'-'+(!max?'nieskonczoność':max)})`);
        }
        return this;
    }

}

export default Validator;